/** Max number of unsynced spaces rendered inside the calendar-sync group. */
export const CALENDAR_SYNC_GROUP_MAX_SPACES = 3;

/** Square thumbnail size (px) used for the space image on each calendar-sync row. */
export const CALENDAR_SYNC_THUMBNAIL_PX = 120;
